import React from "react";
import classNames from "classnames";
import Icon from "../Icon";
import styles from "./ProfileIcon.css";

export default function ProfileIcon(props) {
  return (
    <Icon
      name="user"
      description="profile"
      role="presentation"
      alt=""
      className={classNames(styles.root, props.className)}
    />
  );
}
